import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOnePaymentPayload } from '@app-store/slices/subscriptionPayment/one'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOnePaymentPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.subscriptionPayment.one

function* onePaymentSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/subscriptions/payments/one/${payload.paymentId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* onePaymentSaga(): any {
    yield takeLatest<TaskAction>(onRequest, onePaymentSagaTask)
}

export default onePaymentSaga
